import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	flagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	flagDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	flagActionText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	flagTitle: {
		id: 'forge-ui-controllers.controllers.product-flags.flag-title',
		defaultMessage: '{title}',
		description: 'Title of the flag being shown by the Forge app',
	},
	flagDescription: {
		id: 'forge-ui-controllers.controllers.product-flags.flag-description',
		defaultMessage: '{description}',
		description: 'Description of the flag being shown by the Forge app',
	},
	flagActionText: {
		id: 'forge-ui-controllers.controllers.product-flags.flag-action-text',
		defaultMessage: '{text}',
		description: 'Flag action text of the flag being shown by the Forge app',
	},
});
export default messages;
